"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cancelOrder = void 0;
const helpers_1 = require("../../helpers");
const addOrderLog_1 = require("./addOrderLog");
const getLatestOrderLineVersion_1 = require("./getLatestOrderLineVersion");
const getOrderById_1 = require("./getOrderById");
const getOrderTransactionsByOrderId_1 = require("./getOrderTransactionsByOrderId");
const reverseTransaction_1 = require("./reverseTransaction");
const updateOrderLineVersion_1 = require("./updateOrderLineVersion");
const updateOrderStatus_1 = require("./updateOrderStatus");
const cancelOrder = async (supabase, order_id) => {
    const order = await (0, getOrderById_1.getOrderById)(supabase, order_id);
    if (!order)
        throw new Error("Order not found");
    if (!order.order_lines)
        throw new Error("Order lines not found");
    const golf_lines = order.order_lines.filter((x) => {
        return x.type === "GOLF";
    });
    // get all GOLF order lines.  Cancelling golf lines will cancel the related transfer lines
    for (let i = 0; i < golf_lines.length; i++) {
        const order_line = golf_lines[i];
        if (!order_line.versions)
            throw new Error("Order line does not have versions");
        const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(order_line.versions);
        if (!latest_version)
            throw new Error("Order line does not have a version");
        latest_version.status = helpers_1.OrderLineStatus.CANCELLED;
        // update the order line
        await (0, updateOrderLineVersion_1.updateOrderLineVersion)(supabase, latest_version);
    }
    // mark any change request as complete
    const updateNotesPromises = (order.order_notes || [])
        .filter((note) => note.pinned)
        .map((note) => {
        const { id, pinned } = note;
        return supabase
            .from("order_notes")
            .update({ pinned: pinned })
            .eq("id", id);
    });
    await Promise.all(updateNotesPromises);
    //are there any invoices?
    const order_transactions = await (0, getOrderTransactionsByOrderId_1.getOrderTransactionsByOrderId)(supabase, order.id);
    if (!order_transactions)
        throw new Error("Order transactions not found");
    const receipts = order_transactions.filter((x) => {
        return x.type === "RECEIPT";
    });
    // if invoices, do they have an associated receipt?
    let invoices = order_transactions.filter((x) => {
        return x.type === "INVOICE";
    });
    // filter the invoices to remove those that have a receipt
    invoices = invoices.filter((invoice) => {
        return !receipts.some((receipt) => {
            return invoice.related_transactions.includes(receipt.id);
        });
    });
    for (let i = 0; i < invoices.length; i++) {
        await (0, addOrderLog_1.addOrderLog)(supabase, {
            created_by: order.client?.id,
            type: "PAYMENT",
            order_id: order.id,
            detail: {
                type: "Invoice Reversed",
                status: null,
                title: `${invoices[i].display_name}`,
                message: `Invoice Reversed (${invoices[i].reference}).`,
            },
        });
        await (0, reverseTransaction_1.reverseTransaction)(supabase, invoices[i].id, helpers_1.ADMIN_USER_ID);
    }
    // if not then you can reverse all invoices that are not paid
    await (0, addOrderLog_1.addOrderLog)(supabase, {
        type: "ORDER",
        created_by: order.client?.id,
        order_id: order.id,
        detail: {
            type: "Order Cancelled",
            status: "CANCELLED",
            title: `Order cancelled by client`,
            message: ``,
        },
    });
    await (0, updateOrderStatus_1.updateOrderStatus)(supabase, order, "CANCELLED", order.client?.id);
};
exports.cancelOrder = cancelOrder;
